export const initialData = {
  boards: [
    {
      id: 'board-1',
      columnOrder: ['column-1', 'column-2', 'column-3'],
      columns: [
        {
          id: 'column-1',
          boardId: 'board-1',
          title: 'To do column 1',
          cardOrder: [
            'card-1',
            'card-2',
            'card-3',
            'card-4',
            'card-5',
            'card-6',
            'card-7',
          ],
          cards: [
            {
              id: 'card-1',
              boardId: 'board-1',
              columnId: 'column-1',
              title: 'Title card 1',
              cover:
                'https://images.unsplash.com/photo-1650632566982-5839f8a1493a?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwxMnx8fGVufDB8fHx8&auto=format&fit=crop&w=500&q=60',
            },
            {
              id: 'card-2',
              boardId: 'board-1',
              columnId: 'column-1',
              title: 'Title card 2',
              cover: null,
            },
            {
              id: 'card-3',
              boardId: 'board-1',
              columnId: 'column-1',
              title: 'Title card 3',
              cover: null,
            },
            {
              id: 'card-4',
              boardId: 'board-1',
              columnId: 'column-1',
              title: 'Title card 4',
              cover: null,
            },
            {
              id: 'card-5',
              boardId: 'board-1',
              columnId: 'column-1',
              title: 'Title card 5',
              cover: null,
            },
            {
              id: 'card-6',
              boardId: 'board-1',
              columnId: 'column-1',
              title: 'Title card 6',
              cover: null,
            },
            {
              id: 'card-7',
              boardId: 'board-1',
              columnId: 'column-1',
              title: 'Title card 7',
              cover: null,
            },
          ],
        },
        {
          id: 'column-2',
          boardId: 'board-1',
          title: 'To do column 2',
          cardOrder: ['card-8', 'card-9', 'card-10', 'card-11'],
          cards: [
            {
              id: 'card-8',
              boardId: 'board-1',
              columnId: 'column-2',
              title: 'Title card 8',
              cover:
                'https://images.pexels.com/photos/5029929/pexels-photo-5029929.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
            },
            {
              id: 'card-9',
              boardId: 'board-1',
              columnId: 'column-2',
              title: 'Title card 9',
              cover: null,
            },
            {
              id: 'card-10',
              boardId: 'board-1',
              columnId: 'column-2',
              title: 'Title card 10',
              cover: null,
            },
            {
              id: 'card-11',
              boardId: 'board-1',
              columnId: 'column-2',
              title: 'Title card 11',
              cover:
                'https://images.pexels.com/photos/8160274/pexels-photo-8160274.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
            },
          ],
        },
        {
          id: 'column-3',
          boardId: 'board-1',
          title: 'To do column 3',
          cardOrder: ['card-12', 'card-13', 'card-14'],
          cards: [
            {
              id: 'card-12',
              boardId: 'board-1',
              columnId: 'column-3',
              title:
                'This hook allows you to debounce any fast changing value. The debounced value will only reflect the latest value when the useDebounce hook has not been called for the specified time period.',
              cover:
                'https://images.pexels.com/photos/9225981/pexels-photo-9225981.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
            },
            {
              id: 'card-13',
              boardId: 'board-1',
              columnId: 'column-3',
              title: 'Title card 13',
              cover: null,
            },
            {
              id: 'card-14',
              boardId: 'board-1',
              columnId: 'column-3',
              title: 'Title card 14',
              cover:
                'https://images.pexels.com/photos/11323431/pexels-photo-11323431.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500',
            },
          ],
        },
      ],
    },
  ],
};
